<template>
  <b-form-group
    label="Yönlendirme"
    label-for="target"
  >
    <validation-provider
      #default="{ errors }"
      name="Yönlendirme"
      rules="required"
    >
      <v-select
        v-model="dataItem.target"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ModLeadsTargetSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['modLeads/targetList']
    },
    dataItem() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
